import { useLocale } from '../../context/LocaleContext'

/** Original vector lockup shared with the Coming Soon site. */
export default function SalmaLoadBrand({ tagline = false, className = '' }: { tagline?: boolean; className?: string }) {
  const { t } = useLocale()
  return <span className={`sl-brand ${tagline ? 'sl-brand-with-tagline' : ''} ${className}`}>
    <img className="sl-brand-symbol" src="/brand/salmaload-symbol.svg" alt="" aria-hidden="true" width={393} height={504} />
    <span className="sl-brand-copy">
      <img className="sl-brand-wordmark" src="/brand/salmaload-wordmark.svg" alt="SalmaLoad" width={1366} height={210} />
      {tagline && <span className="sl-brand-tagline">{t('Optimisez vos chargements.', 'Optimize your loads.')}<br />{t('Avancez en confiance.', 'Move forward with confidence.')}</span>}
      <img className="sl-brand-underline" src="/brand/salmaload-underline.svg" alt="" aria-hidden="true" width={1210} height={51} />
    </span>
  </span>
}
